export default __webpack_public_path__ + "static/media/formaticIcon.7b359b3b.svg";